// Centralized runtime error reporter. Today: logs to console.
// Tomorrow: forwards to Rollbar (configuration pending). Keep the
// surface stable so the swap is a one-file change.

export interface ErrorContext {
  source?: 'error-boundary' | 'mutation' | 'query' | 'manual';
  componentStack?: string;
  url?: string;
  userRole?: string | null;
  [key: string]: unknown;
}

export function reportError(error: unknown, context: ErrorContext = {}): void {
  const enrichedContext = {
    ...context,
    // Path only: the board's query string can hold diagnosis-level filters.
    url: context.url ?? (typeof window !== 'undefined' ? window.location.origin + window.location.pathname : undefined),
    timestamp: new Date().toISOString(),
  };

  // eslint-disable-next-line no-console
  console.error('[reportError]', error, enrichedContext);

  // TODO(rollbar): replace the console.error above with:
  //   rollbar.error(error instanceof Error ? error : new Error(String(error)), enrichedContext);
  // and strip location.search in Rollbar's transform: it collects the page URL on its own.
}
